import Vue from 'vue';

export default {
  inject: {
    bus: {
      default: new Vue(),
    },
  },
  computed: {
    isValid() {
      if (this.$v.$anyDirty) {
        return !this.$v.$invalid;
      }
      return null;
    },
  },
  created() {
    this.bus.$emit('pwr-form-register', this);
    if (this.$v) {
      Object.keys(this.$v.$params).forEach((k) => {
        this.$watch(k, () => this.handleValidatedVariableChange(k));
      });
    }
  },
  methods: {
    validate() {
      Object.keys(this.$v.$params).forEach((k) => {
        this.handleValidatedVariableChange(k);
      });
    },
    handleValidatedVariableChange(field) {
      this.$v[field].$touch();
      if (this.$v[field].$invalid) {
        this.emitError();
      } else {
        this.bus.$emit('pwr-form-valid', this.$options.name);
      }
    },
    emitError() {
      const message = {
        field: this.$options.name,
        errors: [],
      };
      message.errors = this.getErrors();
      this.bus.$emit('pwr-form-invalid', message);
    },
    getErrors() {
      console.warn('getErrors() is not defined on your component. This is probably not what you want.');
      return [];
    },
  },
};
